"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainMachine = mapToDomainMachine;
function mapToDomainMachine(dto) {
    return {
        machineId: dto.machineId,
        micronOnlineStatus: dto.micronOnlineStatus,
        totalPowerConsumption: dto.totalPowerConsumption,
        clubId: dto.clubId,
        onlineTime: dto.onlineTime,
        micronMachineId: dto.micronMachineId,
        machineName: dto.machineName,
        clubName: dto.clubName,
    };
}
